const ENGAGEMENT_API = process.env.NEXT_PUBLIC_ENGAGEMENT_API as string;

class APIEndpointsService {
  getRoutes() {
    return {
      airports: {
        get: (id?: string) => id ? `${ENGAGEMENT_API}/airports/v1/${id}` : `${ENGAGEMENT_API}/airports/v1`,
      },
      tripReq: {
        get: (id?: string) => id ? `${ENGAGEMENT_API}/trip-reqs/v1/${id}` : `${ENGAGEMENT_API}/trip-reqs/v1`,
        post: () => `${ENGAGEMENT_API}/trip-reqs/v1`,
      },
      contacts: {
        get: (id?: string) => id ? `${ENGAGEMENT_API}/contacts/v1/${id}` : `${ENGAGEMENT_API}/contacts/v1`,
        post: () => `${ENGAGEMENT_API}/contacts/v1`,
      },
      subscribers: {
        get: (id?: string) => id ? `${ENGAGEMENT_API}/subscribers/v1/${id}` : `${ENGAGEMENT_API}/subscribers/v1`,
        put: () => `${ENGAGEMENT_API}/subscribers/v1`,
      }
    };
  }
}

export default APIEndpointsService;
